import './Navbar.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ActionButtons from './ActionButtons';
import { Route } from '../../types/route';
import { NavbarHeader } from './NavbarHeader';
import { currentVersion } from '../../views/VersionNotes/version-notes';
import { PicaPontoContext } from '../../contexts/PicaPontoContext';


export default function Navbar({ routes, user, setUser, userInfo, setUserInfo }: any) {
    
    const location = useLocation();
    const currentPath = location.pathname.split('/')[1];

    const [navbarOpen, setnavbarOpen] = useState(true);

    const navigate = useNavigate(); 

    useEffect(()=> {
        const modoPicaPonto = localStorage.getItem('modo-pica-ponto');
        if(modoPicaPonto) navigate('/maquina-ponto');
    },[])


    const allowAccess = (route: Route) => {

        if (route.access.includes(userInfo?.roles[0])) {
            return true;
        } else {
            return false;
        }

    }


    return (
        <div className={`text-white bg-rodrimaq-red ${navbarOpen ? 'w-1/6' : 'w-24'} flex flex-col transition-width transition-slowest ease duration-300 rounded-r-xl p-1 h-screen items-stretch max-h-screen`} >
            <NavbarHeader navbarOpen={navbarOpen} setnavbarOpen={setnavbarOpen} />
            
            <div >
                {(user && userInfo) ? <>

                    <ActionButtons setUser={setUser} setUserInfo={setUserInfo} navbarOpen={navbarOpen} />

                    <div className='flex flex-col h-full grow text-sm p-2 max-h-full'>
                        {routes.filter((r: Route) => !r.hidden).filter((r: Route) => allowAccess(r)).map((route: Route, key: number) => {
                            return (
                                <Link
                                    to={route.path}
                                    key={key}
                                    className={`flex py-2 px-2 rounded-md my-0.5  ${navbarOpen ? 'justify-between' :  'justify-center'} items-center text-white ${currentPath !== route.path.split('/')[1] ? 'hover:bg-white hover:text-rodrimaq-red' : 'cursor-default'} ${currentPath === route.path.split('/')[1] ? 'bg-rodrimaq-red-medium shadow-md' : ''}`}
                                    >

                                    <div className={`flex justify-center items-center`}>
                                        <div className={`${navbarOpen? 'mr-4' : ''}`}>{route.icon}</div>
                                        {navbarOpen ? <div >
                                            {route.name}
                                        </div> : null}
                                    </div>

                                    {navbarOpen ? <ChevronRightIcon /> : null}
                                    
                                </Link>
                            )
                        })}
                    </div>

                </> : null}
            </div>
            {/* <div className='absolute bottom-0 pb-2 pl-3 text-sm cursor-pointer' onClick={()=> navigate('/version-notes')}>
                v{currentVersion}
            </div> */}
        </div>
    )

}